module.exports = __webpack_public_path__ + "img/paixu.c5959270.png";